import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

/**
 * Delete component
 */
@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private userService: UserService,
  ) {
    this.activeRoute.params.takeUntil(this.ngUnsubscribe).subscribe((params) => {
      /** Set users selected language for text translations */
      this.translateService.setDefaultLang(params.language);
      this.translateService.use(params.language);

      this.userService
        /** Trigger deletion */
        .deleteUser(params.token)
        .catch((error: Error) => {
          /** On error go to login page */
          this.router.navigate(['/login']);
        });
    });
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/delete/delete.component.ts